export enum ViewContext {
  People = 'People',
  Teams = 'Teams',
  TeamRosters = 'TeamRosters',
  TeamSurvey = 'TeamSurvey',
  Forms = 'Forms',
  TeamBench = 'TeamBench',
  OpportunityBoard = 'OpportunityBoard',
  CredentialingDetailsReport = 'CredentialingDetailsReport',
  AllCredentialingDetailsReport = 'AllCredentialingDetailsReport',
  PersonScenarioReport = 'PersonScenarioReport',
  AllPaymentRecordsReport = 'AllPaymentRecordsReport',
  CredentialPaymentRecordsReport = 'CredentialPaymentRecordsReport',
  PaymentSummaryReport = 'PaymentSummaryReport',
  AllInvoiceReport = 'AllInvoiceReport',
  PersonCredentialApplicationReport = 'PersonCredentialApplicationReport',
  OpportunityBoardReport = 'OpportunityBoardReport',
  Evaluations = 'Evaluations',
  TeamFilter = 'TeamFilter',
  TeamCredentialingDetailsReport = 'TeamCredentialingDetailsReport',
  AllTeamCredentialingDetailsReport = 'AllTeamCredentialingDetailsReport',
  TeamScenarioReport = 'TeamScenarioReport',
  TeamCredentialApplicationReport = 'TeamCredentialApplicationReport',
  TeamPageRosterDetail = 'TeamPageRosterDetail',
  InProgressEntityCredentialApplications = 'InProgressEntityCredentialApplications'
}
